module.exports = __webpack_public_path__ + "static/media/lock.27323c8a.svg";